import { AppProviders } from '@/app/providers';
import { AppRouter } from '@/app/router';
import ReactDOM from 'react-dom/client';
import { env } from './config/env';
import './index.css';
import { useAuthStore } from '@/domains/auth';
import { initializeAnalytics } from '@/integrations/analytics';
import { logger } from '@/lib/logger';
import React from 'react';

// Log application startup
logger.logStartup();

// Handle global auth-logout events (from API 401 errors)
window.addEventListener('auth-logout', () => {
  const { logout } = useAuthStore.getState();
  logout();
  // Redirect to login if not already there
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
});

// Log environment configuration in development
if (env.isDevelopment) {
  logger.logEnvironment();
}

// Initialize Amplitude Analytics
if (env.features.analytics) {
  try {
    initializeAnalytics();
    logger.info('Analytics initialized successfully');
  } catch (error) {
    logger.error('Failed to initialize analytics', error);
  }
} else {
  logger.info('Analytics disabled');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppProviders>
      <AppRouter />
    </AppProviders>
  </React.StrictMode>,
);
